import { Component, OnInit, Input } from '@angular/core';

import { ServicesService } from '../../../services/services/services.service';
import { GlobalCommsService } from '../../../services/global-comms/global-comms.service';

import { VaultAddEditComponent } from './parts/add-edit/add-edit.component';

import { RantSection } from '../../../classes/rant-section';

@Component({
  selector: 'app-rant',
  templateUrl: './rant.component.html',
  styleUrls: ['./rant.component.scss']
})
export class RantComponent implements OnInit {

  @Input() object: Object;
  @Input() summaryOnly: boolean = false;
  key: string;
  extraData: Object;

  content: string;

  sections: RantSection[];

  loading: any;
  saving: Boolean;
  saveText: string;

  constructor(
    private servicesService: ServicesService,
    private modalClose: GlobalCommsService,
  ) {
  }

  ngOnInit() {

    this.key = 'rant-sections';
    this.extraData = {
      heading: this.object['title']['rendered'],
      component: VaultAddEditComponent,
      showSummaryOnly: this.showSummaryOnly(),
      options: {
        class: 'modal-lg'
      },
      section: {
        key: 'rant-sections',
        title: 'The Rant',
        type: 'children',
        childType: 'rant-sections',
        plural: 'rant sections',
        singular: 'Rant section',
        min: 0,
        max: 0,
      },
    }

    this.modalClose.currentRef.subscribe(
      modalStatus => {

        if( typeof( modalStatus ) !== 'object' ) {
          return;
        }

        if( modalStatus['action'] === 'replace-items' && typeof( modalStatus['items'] ) !== 'undefined' ) {
          this.sections = modalStatus['items'];
        }

      }
    );

    this.loadSections();

  }

  loadSections() {

    this.loading = true;

    this.servicesService.getServiceParts( this.object['id'] , this.key ).subscribe(

      resp => {
        this.sections = resp;
        this.loading = false;
      },

      error => {
        this.loading = false;
      }

    );

  }

  showSummaryOnly() {

    if( typeof( this.object ) === 'undefined' ) {
      return true;
    }

    return this.summaryOnly;

  }

}
